/*
 * @Author: daniel
 * @Date: 2020-11-03 15:13:59
 * @Description 监听跟踪当前用户在页面上的浏览时长
 */
import { getClientBaseData } from '@/utils/track'

/**
 * 设置路由追踪
 * @param {object} router - Vue Router 实例
 * @param {object} store - Vuex Store 实例
 * @param {object} axios - Axios 实例
 */
export function setupRouteTracker(router, store, axios) {
  const debug = true
  // 确保只在客户端执行
  if (typeof window !== 'undefined' && (process.env.NODE_ENV === 'production' || debug)) {
    router.afterEach((to, from) => {
      console.warn('track-route afterEach triggered for path:', to.path)
      console.log('router-to', to)
      console.log('router-from', from)

      // 基础数据
      const base = getClientBaseData()

      console.log('track-base', base)
      // 拼接参数串
      let args = ''
      for (const i in base) {
        if (args !== '') {
          args += '&'
        }
        args += `${i}=${encodeURIComponent(base[i])}`
      }
      console.log('track-args', args)

      // 通过Image对象请求后端脚本 (原逻辑被注释，保持不变)
      // const img = new Image(1, 1)
      // img.src = 'http://analytics.codinglabs.org/1.gif?' + args

      const trackParam = {
        moduleId: 0,
        browseDuration: 0,
        bizUnicode: '',
        bizId: '',
        targetMemberCode: '',
      }
      // 此处可以添加使用 axios 发送追踪数据的逻辑
      // axios.post('/api/track', trackParam);
    })
  }
}
